import {
  Box, Paper, Skeleton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from '@mui/material'
import { JournalListItem } from './journal-list-item'

const SKELETON_ROWS = 6

const SkeletonRows = () =>
  Array(SKELETON_ROWS).fill(0).map((_, i) => (
    <TableRow key={i}>
      <TableCell><Skeleton variant="text" width="80%" /></TableCell>
      <TableCell><Skeleton variant="circular" width={24} height={24} /></TableCell>
      <TableCell><Skeleton variant="text" width={100} /></TableCell>
      <TableCell><Skeleton variant="text" width="70%" /></TableCell>
      <TableCell><Skeleton variant="text" width="90%" /></TableCell>
    </TableRow>
  ))

export const JournalList = ({ entries, loading, selectedId, onSelect }) => {
  const isEmpty = !loading && entries.length === 0

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ flex: 1, overflow: 'auto' }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Subject</TableCell>
            <TableCell>Written By</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Contents</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && <SkeletonRows />}
          {!loading && isEmpty && (
            <TableRow>
              <TableCell colSpan={5}>
                <Box sx={{ py: 4, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    No journal entries found for this season.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}
          {!loading && entries.map(entry => (
            <JournalListItem
              key={entry.id}
              entry={entry}
              selected={entry.id === selectedId}
              onClick={() => onSelect(entry.id === selectedId ? null : entry)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
